import { API_URLs } from "../../../../utilities/API_URLs"
import iAxios from "../../../../utilities/axios/axios-setup"
import { Http } from "../../../../utilities/axios/http"
import { OpenStoragePageState, NewOpenStorageRequest } from "./_model"
// import { NewRoleData, UserRolePageState } from "./_model"

/* export const postNewOpenStorage = (data: NewOpenStorageRequest) => {
  return iAxios.post(API_URLs.settings.openStorage.postOpenStorage, data)
  .then(r => {
    return r.data
  })
  .catch(e => {
    return e
  })
}

export const getOpenStorageList = (pageState: OpenStoragePageState) => {
  const obj: any = {...pageState}
  Object.keys(pageState).forEach((key: any) => {
    if (key === 'order') {
      console.log('The order key ')
      obj['order[' + (pageState?.order?.dataKey ?? '') + ']'] = pageState?.order?.order;
    } else {
      obj[key] = obj[key]?.toString()
    }
    
  })
  delete obj['order']
  return iAxios.get(API_URLs.settings.openStorage.getOpenStorages + '?' + new URLSearchParams(obj) )
  .then(r => {
    return r?.data
  })
  .catch(e => {
    return null
  })
}

export const getOpenStorageById = (id: string) => {
  return iAxios.get(API_URLs.settings.openStorage.getOpenStorageById?.replace('{id}', id))
  .then(r => r.data)
  .catch(e => null)
}

export const patchOpenStorageById = (id: string, data: NewOpenStorageRequest) => {
  return iAxios.patch(API_URLs.settings.openStorage.patchOpenStorageById?.replace('{id}', id), {...data, id}, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
    }
  })
  .then(r => {
    return r.data
  })
  .catch(e => {
    return e
  })
}

export const deleteOpenStorageById = (id: string) => {
  return iAxios.delete(API_URLs.settings.openStorage.deleteOpenStorageById?.replace('{id}', id))
  .then(r => ({success: true, data: r.data}))
  .catch(e => null)
} */

export class OpenStorageService {
  static postOpenStorage = async (data: any) => {
    try {
      return await Http.post(API_URLs.settings.openStorage.openStorageUrl, data);
    } catch (error) {
      return error
    }
  }

  static getOpenStorage = async (id: number) => {
    try {
      return await Http.get(`${API_URLs.settings.openStorage.openStorageUrl}/${id}`);
    } catch (error) {
      return error
    }
  }

  static getOpenStorageList = async (params?: any) => {
    try {
      return await Http.get(API_URLs.settings.openStorage.openStorageUrl, params)
    } catch (error) {
      return error;
    }
  }

  static updateOpenStorage = async (data: any) => {
    try {
      return await Http.patch(API_URLs.settings.openStorage.openStorageUrl, data);
    } catch (error) {
      return error;
    }
  }

  static deleteOpenStorage = async (id: number) => {
    try {
      return await Http.delete(`${API_URLs.settings.openStorage.openStorageUrl}/${id}`);
    } catch (error) {
      return error;
    }
  }
}